import { render, staticRenderFns } from "./Relay.vue?vue&type=template&id=6c288ff6&"
import script from "./Relay.vue?vue&type=script&lang=js&"
export * from "./Relay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports